import de from '@/utils/primevue-locale/de.json';
import en from '@/utils/primevue-locale/en.json';
import fr from '@/utils/primevue-locale/fr.json';
import it from '@/utils/primevue-locale/it.json';
import type { PrimeVueLocaleOptions } from 'primevue/config';

export const primeLocaleByCode: Record<string, PrimeVueLocaleOptions> = {
  en,
  fr,
  de,
  it,
};
